import type { ApiBackend } from '@plathunt/api';

/**
 * Nur oeffentliche Werte. Der Secret Key, IGDB- und PSN-Secrets gehoeren
 * ausschliesslich serverseitig und tauchen hier nie auf.
 *
 * Supabase hat die Keys umbenannt: Publishable Key ersetzt den anon Key.
 * Der alte Name wird als Fallback akzeptiert, solange beide Schemata parallel
 * gueltig sind.
 */
const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const publishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

export const supabaseConfigured = Boolean(url && publishableKey);

/** Ohne Supabase-Konfiguration laeuft die App auf den DEV FIXTURES. */
export const apiBackend: ApiBackend = supabaseConfigured ? 'supabase' : 'memory';

export const supabaseConfig = { url, publishableKey };

/**
 * Sicherheitsnetz gegen den teuersten moeglichen Fehler: ein Secret Key im
 * Client-Bundle. Faellt beim Start sofort auf, statt still zu funktionieren.
 */
if (publishableKey.startsWith('sb_secret_')) {
  throw new Error(
    'VITE_SUPABASE_PUBLISHABLE_KEY enthaelt einen Secret Key (sb_secret_...). ' +
      'Der gehoert niemals in den Client. Bitte den Publishable Key (sb_publishable_...) eintragen.',
  );
}
